import React, { useState } from 'react'
import aboutData from "../../data/about.json"
import images from '../../assets/images/Constant';

const AboutCompany = () => {
  const { aboutSection } = aboutData;

  const [activeTab, setActiveTab] = useState(0);

  const activeContent = aboutSection.tabs[activeTab].description;

  return (
    <section className="relative w-full">

      {/* BG */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${images[aboutSection.bgImage]})` }}
      />

      {/* CONTENT */}
      <div className="relative z-10 max-w-[1200px] mx-auto px-4 sm:px-6 py-12 md:py-20 flex flex-col lg:flex-row gap-8 lg:gap-5 items-stretch">

        {/* LEFT */}
        <div className="flex-1 min-h-[240px] h-[280px] sm:h-[360px] lg:h-[520px]">
  <img
    src={images[aboutSection.leftImage]}
    className="w-full h-full object-cover"
    alt=""
  />
</div>
        {/* RIGHT */}
       <div className="flex-1 min-h-0 lg:h-[520px] flex flex-col justify-between min-w-0 py-2 lg:py-0">

  {/* SUBTITLE */}
  <div className="flex items-center gap-3 mb-4">
    <img src={images[aboutSection.icon]} alt="" className="w-6 h-6" />
    <p className="uppercase text-primary text-sm sm:text-lg md:text-[22px] leading-tight">
      {aboutSection.subtitle}
    </p>
  </div>

  {/* TITLE */}
  <h1 className="text-3xl md:text-heading font-semibold leading-tight text-dark pb-5">
    {aboutSection.title}
  </h1>

  {/* TABS */}
  <div className="flex flex-wrap gap-2 sm:gap-3 md:gap-4 mt-6">
    {aboutSection.tabs.map((tab, index) => (
      <button
        key={index}
        onClick={() => setActiveTab(index)}
        onMouseEnter={() => setActiveTab(index)}
        className={`px-4 sm:px-6 md:px-8 py-2 text-sm sm:text-base rounded transition ${
          activeTab === index
            ? "bg-primary text-white"
            : "border border-dark text-dark"
        }`}
      >
        {tab.title}
      </button>
    ))}
  </div>

  {/* DESCRIPTION */}
  <div className="mt-4 text-light">

    {activeContent?.intro && (
      <p className="break-words leading-relaxed">
        {activeContent.intro}
      </p>
    )}

    {activeContent?.points && (
      <ul className="list-disc  pl-7  break-words">
        {activeContent.points.map((point, i) => (
          <li key={i}>{point}</li>
        ))}
      </ul>
    )}

    {activeContent?.footer && (
      <p className="break-words leading-relaxed">
        {activeContent.footer}
      </p>
    )}

  </div>
</div>
      </div>
    </section>
  )
}

export default AboutCompany